<script setup lang="ts">
import { actionIcons } from '@/constants'
import Typography from '../ui/typography/Typography.vue'
import type { PlayerAction } from '@acepoker/contract/src/action'
import { useI18n } from 'vue-i18n'

const { item, isLast } = defineProps<{ item: PlayerAction; isLast?: boolean }>()
const { t } = useI18n()
</script>

<template>
  <div
    class="flex flex-row w-max h-[24px] border border-1 py-[3px] pr-[3px] pl-[6px] gap-[6px] text-secondary items-center rounded"
    :class="{
      'border-c4': (item.action === 'raise' || item.action === 'bet') && !isLast,
      'border-highlight': isLast
    }"
  >
    <Typography variant="topbarItem">{{ item.role }} </Typography>
    <div
      class="flex flex-row bg-menu-item-bg items-center rounded-[2px] px-[6px] h-[18px] gap-[4px] text-white"
    >
      <Typography variant="topbarItem"
        >{{ t(`label.${item.action}`) }} {{ item.amount }}</Typography
      >
      <!-- <component
        v-if="item.quality"
        :is="actionIcons[item.quality]"
        width="18px"
        height="20px"
        alt="quality"
        class="[&>rect]:fill-none"
      /> -->
    </div>
    <!-- <div v-if="isLast" class="bg-highlight text-white h-[20px] rounded-[2px] px-[6px] gap-[6px]">
      Take Action
    </div> -->
  </div>
</template>
